module.exports = __webpack_public_path__ + "img/gear-wide-connected.5ac7fb23.svg";